const FILTER_ATTEMPTS = 120;
const INITIALIZE_DELAY_MS = 0;
const FILTER_RETRY_DELAY_MS = 250;
const FILTER_SETTLE_DELAYS = [200, 500, 1000, 2000];

class SybilMemberStories extends HTMLElement {
  connectedCallback() {
    this.section = this.closest('.sybil-member-stories');
    this.featuredDecoration = this.querySelector('[data-sybil-featured-review-decoration]');
    this.attempt = 0;
    this.filterApplied = false;
    this.settleTimers = [];
    this.initializeTimer = setTimeout(() => this.initializeWidget(), INITIALIZE_DELAY_MS);
  }

  disconnectedCallback() {
    clearTimeout(this.initializeTimer);
    clearTimeout(this.retryTimer);
    this.settleTimers.forEach((timer) => clearTimeout(timer));
  }

  initializeWidget() {
    const widget = this.querySelector('.jdgm-rev-widg');
    const reviews = widget?.querySelectorAll('.jdgm-rev');

    if (!widget || !reviews?.length) {
      this.retry();
      return;
    }

    if (this.section?.dataset.reviewSelection === 'recent_five_star' && !this.filterApplied) {
      const fiveStarFilter = widget.querySelector(
        '.jdgm-histogram__row[data-rating="5"] [role="button"]',
      );

      if (!fiveStarFilter) {
        this.retry();
        return;
      }

      this.filterApplied = true;
      fiveStarFilter.click();
      this.settleTimers = FILTER_SETTLE_DELAYS.map((delay) =>
        setTimeout(() => this.markReady(), delay),
      );
      return;
    }

    this.markReady();
  }

  retry() {
    this.attempt += 1;
    if (this.attempt >= FILTER_ATTEMPTS) return;
    clearTimeout(this.retryTimer);
    this.retryTimer = setTimeout(() => this.initializeWidget(), FILTER_RETRY_DELAY_MS);
  }

  markReady() {
    const firstReview = this.querySelector('.jdgm-rev');
    if (!this.section || !firstReview) return;

    const decoration = this.featuredDecoration;
    if (decoration && !firstReview.contains(decoration)) {
      firstReview.append(decoration);
    }
    this.section.dataset.reviewsReady = 'true';
  }
}

if (!customElements.get('sybil-member-stories')) {
  customElements.define('sybil-member-stories', SybilMemberStories);
}
